import { axiosV2 } from 'interceptors/axios';

import { Note } from 'types';

import { decryptResponse } from 'utils/token';

type UpdateNoteProps = {
  noteId: string;
  updateNoteData: Partial<Note>;
};

export const updateNote =
  ({ noteId, updateNoteData }: UpdateNoteProps) =>
  async () => {
    const body = { ...updateNoteData };

    const { data } = await axiosV2.put(`/notes/${noteId}`, body);

    const decodedData = await decryptResponse(data);

    return decodedData;
  };
